export const SET_ORIGIN_CATEGORY = "SET_ORIGIN_CATEGORY";
export const SET_ORIGINS_CATEGORIES = "SET_ORIGINS_CATEGORIES";
export const ADD_ORIGIN_CATEGORY = "ADD_ORIGIN_CATEGORY";
export const UPDATE_ORIGIN_CATEGORY = "UPDATE_ORIGIN_CATEGORY";
export const RESET_ORIGINS_CATEGORIES = "RESET_ORIGINS_CATEGORIES";
